import request from '@/utils/request'

// 01获取首页详情
export function getIndexDetailApi() {
  return request({
    method: 'GET',
    url: 'v1/web/index/detail'
  })
}

// 获取首页分类
export function getIndexCategoryListApi(data) {
  return request({
    method: 'POST',
    url: 'v1/web/index/category/list',
    data
  })
}
//03获取首页套餐列表
export function getIndexProductPackageListApi(data) {
  return request({
    method: 'POST',
    url: 'v1/web/index/product/package/list',
    data
  })
}
// 04获取首页单品列表
export function getIndexProductListApi(data) {
  return request({
    method: 'POST',
    url: 'v1/web/index/product/list',
    data
  })
}
